import React from 'react';

const pageStyle = {
  minHeight: '100vh',
  background: '#000000',
  padding: '40px 20px',
  display: 'flex',
  justifyContent: 'center',
};

const cardStyle = {
  width: '100%',
  maxWidth: '900px',
  background: '#ffffff',
  borderRadius: '16px',
  boxShadow: '0 8px 26px rgba(0,0,0,0.08)',
  border: '1px solid #e8efeb',
  padding: '30px',
  color: '#1e1e1e',
  fontFamily: 'Montserrat, sans-serif',
  lineHeight: 1.65,
};

const headingStyle = {
  fontFamily: 'FontSemi',
  color: '#111',
  marginTop: 0,
  marginBottom: 8,
  fontSize: '34px',
};

const subStyle = {
  marginTop: 0,
  marginBottom: 24,
  color: '#4a4a4a',
  fontSize: 14,
};

const sectionTitleStyle = {
  fontFamily: 'FontSemi',
  fontSize: 20,
  marginTop: 24,
  marginBottom: 10,
  color: '#111',
};

const bulletListStyle = {
  marginTop: 0,
  paddingLeft: 20,
};

export default function PrivacyPolicy() {
  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h1 style={headingStyle}>Privacy Policy & Terms & Conditions</h1>
        <p style={subStyle}>Effective Date: August 1, 2026</p>

        <h2 style={sectionTitleStyle}>1. Overview</h2>
        <p>
          Mickey Subs (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) values your privacy. This Privacy Policy explains how we collect,
          use, disclose, and protect personal information when you use our website, mobile application, or related services.
        </p>
        <p>
          By using our services, you agree to the collection and use of information in accordance with this policy.
        </p>

        <h2 style={sectionTitleStyle}>2. Information We Collect</h2>
        <p>We may collect information that identifies you or relates to you, including:</p>
        <ul style={bulletListStyle}>
          <li>Full name and contact information</li>
          <li>Email address and account credentials</li>
          <li>Order history, preferences, and delivery details</li>
          <li>Profile information you provide to us</li>
          <li>Authentication data managed through Firebase Auth</li>
          <li>App usage, browsing, and interaction data</li>
          <li>Device, operating system, browser, and technical diagnostics</li>
          <li>Saved credit card information used to facilitate repeat purchases</li>
          <li>Payment and transaction information used to complete purchases</li>
        </ul>

        <h2 style={sectionTitleStyle}>3. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul style={bulletListStyle}>
          <li>Create and manage your account</li>
          <li>Process orders, transactions, and refunds</li>
          <li>Provide customer support and respond to requests</li>
          <li>Improve site and app functionality, reliability, and user experience</li>
          <li>Send important service updates, account notifications, and operational communications</li>
          <li>Detect and prevent fraud, abuse, security issues, and unauthorized activity</li>
          <li>Analyze usage trends and improve our offerings</li>
        </ul>

        <h2 style={sectionTitleStyle}>4. Data Sharing and Disclosure</h2>
        <p>
          We do not sell your personal information. We may share information only when necessary to provide our services or comply with legal obligations.
          This may include trusted service providers such as:
        </p>
        <ul style={bulletListStyle}>
          <li>Authentication providers</li>
          <li>Hosting and infrastructure providers</li>
          <li>Payment processors and financial service partners</li>
          <li>Analytics and customer support tools</li>
          <li>Legal or governmental entities when required by law</li>
        </ul>
        <p>
          We require these third parties to use the information only for the services they provide to us and to protect it appropriately.
        </p>

        <h2 style={sectionTitleStyle}>5. Cookies, Tracking, and Analytics</h2>
        <p>
          We may use cookies, mobile identifiers, web beacons, and similar technologies to understand how users interact with our services,
          remember preferences, and improve performance. These tools may collect information such as session activity, device type, and usage patterns.
        </p>
        <p>
          You may be able to disable cookies in your device or browser settings, but some parts of the service may not function properly if tracking is disabled.
        </p>

        <h2 id="account-deletion" style={sectionTitleStyle}>6. Your Choices and Rights</h2>
        <p>You may have rights to:</p>
        <ul style={bulletListStyle}>
          <li>Access the personal information we hold about you</li>
          <li>Request correction or updates to inaccurate information</li>
          <li>Request deletion of your personal information, subject to legal limitations</li>
          <li>Opt out of marketing or non-essential communications</li>
          <li>Restrict or object to certain uses of your data</li>
        </ul>
        <p>
          If you want to exercise any of these rights, contact us using the information below in this policy.
        </p>
        <p>
          To request account or personal-data deletion, email <strong>info@clientellapps.com</strong> and include the email address associated with your account.
        </p>

        <h2 style={sectionTitleStyle}>7. Data Retention</h2>
        <p>
          We retain personal information only as long as necessary to provide services, comply with legal obligations, resolve disputes,
          and enforce our agreements. When information is no longer needed, we securely delete or anonymize it where feasible.
        </p>

        <h2 style={sectionTitleStyle}>8. Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational safeguards to help protect personal information from unauthorized access,
          loss, misuse, or disclosure. However, no system is completely secure, and we cannot guarantee absolute security.
        </p>

        <h2 style={sectionTitleStyle}>9. Third-Party Links and Services</h2>
        <p>
          Our services may include links to third-party websites or integrations. We are not responsible for the privacy practices of those third parties,
          and we encourage you to review their privacy policies before sharing information with them.
        </p>

        <h2 style={sectionTitleStyle}>10. Age Requirements</h2>
        <p>
          Our services are intended for users who are old enough to create and manage an account and complete transactions in accordance with applicable law.
          We do not currently provide a dedicated child account or age-specific sign-up flow, and we do not knowingly collect personal information from users who are under the age required to use our services.
        </p>
        <p>
          If we become aware that a user under the required age has provided personal information, we will take reasonable steps to remove that information and restrict access to the account.
        </p>

        <h2 style={sectionTitleStyle}>11. Terms of Service</h2>
        <p>
          By using Mickey Subs services, you agree to provide accurate information, use the platform only for lawful purposes, and refrain from abusing, interfering with,
          or attempting to compromise the service, accounts, or systems of others.
        </p>
        <ul style={bulletListStyle}>
          <li>You are responsible for maintaining the confidentiality of your account and login information.</li>
          <li>You agree to pay all charges for products and services ordered through the platform.</li>
          <li>We reserve the right to refuse service, suspend accounts, or cancel orders when necessary to protect the integrity of the service or comply with law.</li>
          <li>Orders, pricing, menu availability, and promotions may change without prior notice.</li>
        </ul>
        <p>
          We are not liable for lost, delayed, mismatched, or uncredited loyalty or rewards points resulting from the use of different email addresses,
          failure to enter an email address, use of different platforms or accounts, or other account-matching issues. Customers may submit disputes or
          requests for review regarding rewards-point balances, but adjustments, credits, or reinstatements are not guaranteed.
        </p>

        <h2 style={sectionTitleStyle}>12. Arbitration</h2>
        <p>
          Any dispute arising out of or relating to this Privacy Policy, these Terms, our data practices, or your use of our services shall be resolved through binding arbitration
          administered under the rules of the American Arbitration Association in the state of Florida, unless otherwise required by applicable law.
        </p>
        <p>
          The arbitration shall be conducted by a single arbitrator experienced in privacy, consumer, or technology disputes, and the decision of the arbitrator shall be final and binding.
          Each party shall bear its own costs of arbitration, except as otherwise required by the governing arbitration rules.
        </p>

        <h2 style={sectionTitleStyle}>13. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy and Terms from time to time. If we make material changes, we will revise the effective date and post the updated policy
          in our app or on our website. Continued use of the service after the changes become effective indicates your acceptance of the updated terms and policy.
        </p>

        <h2 style={sectionTitleStyle}>14. Contact Us</h2>
        <p>
          If you have questions, concerns, or requests regarding this Privacy Policy, these Terms, or your personal information, please contact us at:
        </p>
        <p><strong>Email:</strong> info@clientellapps.com</p>
      </div>
    </div>
  );
}
